import { render, staticRenderFns } from "./newProductDetils.vue?vue&type=template&id=f4c79a2e&scoped=true"
import script from "./newProductDetils.vue?vue&type=script&lang=js"
export * from "./newProductDetils.vue?vue&type=script&lang=js"
import style0 from "./newProductDetils.vue?vue&type=style&index=0&id=f4c79a2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c79a2e",
  null
  
)

export default component.exports